<div class="d-flex mb-2 alert-warning-box" *ngIf="alertBannerShow">
    <div class="d-flex align-items-center">
        <img class="ml-4" src="../../../../assets/icons/warning_red_new.png"/>
    </div>
    <div class="col d-flex align-items-center">
        <p class="message mb-0">
            Please add your receiving hours for all future order shipments for location {{accountNumber}}. 
            <a class="link" (click)="goToProfileAccount()">Add receiving hours</a>
        </p>
    </div>
    <div class="col-2 alert-close-homepg">
        <p class="hours-close-banner" (click)="closeBanner()"></p>
    </div>
</div>